(function () {
  const RULE = 'iphone-18-to-17-v2';

  function getConfig(sectionId) {
    return Array.from(document.querySelectorAll('[data-iphone-alias-config]'))
      .filter((node) => String(node.dataset.section) === String(sectionId))
      .map((node) => {
        try {
          return JSON.parse(node.textContent);
        } catch (error) {
          console.error('iPhone alias configuration is invalid.', error);
          return null;
        }
      })
      .find(Boolean);
  }

  function getMapping(sectionId, variantId) {
    const config = getConfig(sectionId);
    const mapping = config?.mappings?.[String(variantId)];
    if (!mapping || mapping.selectedAvailable || !mapping.sourceAvailable) return null;
    return mapping;
  }

  function selectedVariantId(sectionId) {
    return document.querySelector(`#product-form-${sectionId} input[name="id"]`)?.value;
  }

  function setAcceleratedCheckoutVisibility(sectionId, hidden) {
    const wrapper = document.querySelector(
      `[data-iphone-alias-dynamic-checkout][data-section="${sectionId}"]`
    );
    if (!wrapper) return;
    wrapper.hidden = hidden;
    wrapper.setAttribute('aria-hidden', hidden ? 'true' : 'false');
  }

  function sync(sectionId, variantId) {
    const mapping = getMapping(sectionId, variantId || selectedVariantId(sectionId));
    document
      .getElementById(`MainProduct-${sectionId}`)
      ?.classList.toggle('iphone-alias-active', Boolean(mapping));
    setAcceleratedCheckoutVisibility(sectionId, Boolean(mapping));
    return mapping;
  }

  function applyToFormData(sectionId, formData) {
    const selectedId = formData.get('id');
    const mapping = getMapping(sectionId, selectedId);
    if (!mapping) return null;

    formData.set('id', mapping.sourceVariantId);
    formData.set('properties[Customer selected]', mapping.selectedModel);
    formData.set('properties[_customer_selected_model]', mapping.selectedModel);
    formData.set('properties[_fulfilled_as]', mapping.fulfilledAs);
    formData.set('properties[_alias_selected_variant_id]', String(selectedId));
    formData.set('properties[_alias_source_variant_id]', String(mapping.sourceVariantId));
    formData.set('properties[_alias_rule]', RULE);
    formData.set('properties[_alias_order_tag]', mapping.orderTag);
    return mapping;
  }

  window.IphoneAlias = {
    applyToFormData,
    getMapping,
    sync,
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-iphone-alias-config]').forEach((node) => {
      sync(node.dataset.section);
    });
  });
})();
